import type { SVGProps } from 'react';
const SvgHomeFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#home_filled_svg__a)">
      <path fill="currentColor" d="M12 3 4 9v12h5v-7h6v7h5V9l-8-6Z" />
    </g>
    <defs>
      <clipPath id="home_filled_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeFilled;
